import Vue from 'vue'
import App from './App'
import * as firebase from 'firebase/app'
import router from './router'
import { store } from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// Internationalization:
import vuexI18n from 'vuex-i18n'
import * as firestoreTranslations from './messages/firestoreTranslations'
import * as customMessages from './messages/customMessages'
import * as sharedMessages from './messages/sharedMessages'
import * as simpleMenuMessages from './messages/simpleMenuMessages'

// TODO: Clean, some components aren't being used anymore
Vue.use(Vuetify);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created() {
    // Init firebase
    const config = {
      apiKey: "AIzaSyBpPWCq6serbEe67tUDAle-gDdgF8sKiog",
      authDomain: "alioli-d4093.firebaseapp.com",
      databaseURL: "https://alioli-d4093.firebaseio.com",
      projectId: "alioli-d4093",
      storageBucket: "alioli-d4093.appspot.com",
      messagingSenderId: "406654927589"
    };

    firebase.initializeApp(config);

    // Solve firebase warnings with necessary firestore settings:
    const settings = {};

    firebase.firestore().settings(settings);


    // Init translations

    // -------------Internationalization--------------------
    Vue.use(vuexI18n.plugin, store);

    // Add translations
    Vue.i18n.add('en', firestoreTranslations.EN);
    Vue.i18n.add('es', firestoreTranslations.ES);
    Vue.i18n.add('nl', firestoreTranslations.NL);
    Vue.i18n.add('de', firestoreTranslations.DE);
    Vue.i18n.add('fr', firestoreTranslations.FR);
    Vue.i18n.add('sv', firestoreTranslations.SV);
    Vue.i18n.add('zh', firestoreTranslations.ZH);
    Vue.i18n.add('it', firestoreTranslations.IT);
    Vue.i18n.add('ar', firestoreTranslations.AR);
    Vue.i18n.add('pt', firestoreTranslations.PT);


    Vue.i18n.add('en', customMessages.EN);
    Vue.i18n.add('es', customMessages.ES);

    Vue.i18n.add('en', sharedMessages.EN);
    Vue.i18n.add('es', sharedMessages.ES);
    Vue.i18n.add('nl', sharedMessages.NL);
    Vue.i18n.add('fr', sharedMessages.FR);
    Vue.i18n.add('zh', sharedMessages.ZH);
    Vue.i18n.add('pt', sharedMessages.PT);
    Vue.i18n.add('ar', sharedMessages.AR);
    Vue.i18n.add('it', sharedMessages.IT);
    Vue.i18n.add('de', sharedMessages.DE);




    Vue.i18n.add('en', simpleMenuMessages.EN);
    Vue.i18n.add('es', simpleMenuMessages.ES);

    // Get locale from the user's browser
    const locale = navigator.language;
    console.log("Current locale: " + locale);

    // Use current locale
    Vue.i18n.set(locale);

    // Sets fallback locale in case there's no translation for current locale
    Vue.i18n.fallback('en');
    // -----------------------------------------------------
  }
});



// WEBPACK FOOTER //
// ./src/main.js